import { ADD_TOAST, CLEAR_TOASTS, REMOVE_TOAST, RESET_TOASTS } from './constants.js';

function addToast(toast) {
  return {
    payload: toast,
    type: ADD_TOAST
  };
}

function clearToasts() {
  return {
    type: CLEAR_TOASTS
  };
}

function removeToast(toastId) {
  return {
    payload: toastId,
    type: REMOVE_TOAST
  };
}

function resetToasts() {
  return {
    type: RESET_TOASTS
  };
}

export { addToast, clearToasts, removeToast, resetToasts };
